import React, { useEffect, useState } from 'react';
import { Qualaroo } from '../../libs/gs-component-form';
import { set } from 'js-cookie';

import { useRegistrySummaryQuery, useWeddingWebsiteQuery } from '../../generated/graphql';
import { getDaysCreated, getDaysLeft } from '../../helpers/getCountDown';
import registryInfo from '../../helpers/registryInfo';
import { useHasRsvpsCollected } from '../../helpers/useHasRsvpCollected';
import useIsLiteSite from '../../helpers/useIsLiteSite';
import { useUpdateFirstInteractionMutation } from '../../generated/graphql';

interface Props {
  weddingWebsite?: {
    firstDashboardInteraction?: string | null;
  } | null;
  member?: {
    email?: string | null;
  } | null;
}

const HIDE_QUALAROO_COOKIE = '__qual_seen';

const FirstInteraction: React.FC<Props> = ({ weddingWebsite, member }) => {
  const { firstDashboardInteraction } = weddingWebsite || {};
  const { email } = member || {};
  const [update] = useUpdateFirstInteractionMutation();
  const [identifier, setIdentifier] = useState<string>();
  const { data } = useWeddingWebsiteQuery();
  const { data: registryData } = useRegistrySummaryQuery();
  const { hasAnyRegistry } = registryInfo(registryData?.registrySummary);
  const hasRsvpsCollected = useHasRsvpsCollected();
  const isliteSite = useIsLiteSite();

  const properties = {
    admin_version: 'cv2',
    show_cv_survey: true,
    days_till_wedding: getDaysLeft(data?.wedding?.weddingDate),
    has_registries: hasAnyRegistry,
    has_rsvps: hasRsvpsCollected,
    is_lite_site: isliteSite,
    website_days_created: getDaysCreated(data?.weddingWebsite.websiteCreatedAt),
  };

  useEffect(() => {
    if (email) {
      setIdentifier(email);
    }

    if (firstDashboardInteraction === null) {
      const date = new Date();

      const variables = {
        attributes: {
          firstDashboardInteraction: date.toISOString(),
        },
      };

      update({ variables });

      set(HIDE_QUALAROO_COOKIE, '1', { expires: 1 /*day*/ });
    }
  }, [update, firstDashboardInteraction, email]);

  if (!identifier) {
    return null;
  }

  return <Qualaroo properties={properties} identifier={identifier} />;
};

export default FirstInteraction;
